<template>
    <div>
        <div class="comp-reset-num comp">
            <div class="bizcomp-reset-lpwd-title">
                找回密码
                <div v-show="selectedOption == null" class="lpwd-title-tip">
                    请选择找回密码方式:
                </div>
            </div>
            <div v-show="selectedOption == null" class="recoveryOptions-container">
                <div
                    v-for="(option, index) in recoveryOptions"
                    :key="index"
                    class="recovery-option selectedOption"
                    :class="{ selected: selectedOption === option.id }"
                    v-on:click="selectOption(option.id)"
                >
                    <p class="title">{{ option.title }}</p>
                    <p v-if="option.subtitle" class="subtitle">{{ option.subtitle }}</p>
                    <button v-on:click.stop="selectOption(option.id)">
                        {{ option.buttonText || "找回密码" }} ->
                    </button>
                </div>
            </div>
            <retrieve-pwd-new
                v-if="['0', '1'].includes(passwordType) && selectedOption != null"
                :way="way"
                :pwdrecoverytype="selectedOption"
                v-on:returnBack="goBack"
            />
            <retrieve-pwd
                v-else-if="
                    !['0', '1'].includes(passwordType) && selectedOption != null && pwdPattern
                "
                :way="way"
                :pwdrecoverytype="selectedOption"
                v-on:returnBack="goBack"
                v-on:reSelect="selectOption"
            />
            <reset-login-pwd
                v-else-if="
                    !['0', '1'].includes(passwordType) && selectedOption != null && !pwdPattern
                "
                :way="way"
                :pwd-pattern="pwdPattern"
                v-on:returnBack="goBack"
            />
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import retrievePwd from "@/components/acctInfo/retrievePwd.vue";
import resetLoginPwd from "@/components/acctInfo/resetPwdDc.vue";
import RetrievePwdNew from "@/components/acctInfo/retrievePwdNew.vue";
export default {
    name: "PwdRecovery",
    components: {
        footerQuestions,
        retrievePwd,
        resetLoginPwd,
        RetrievePwdNew
    },
    props: {
        way: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            recoveryOptions: [
                {
                    id: 0,
                    title: "我在XXX直销开过户",
                    subtitle: "已通过实名认证客户",
                    buttonText: "找回密码"
                },
                {
                    id: 1,
                    title: "我只在代销机构购买过XXX的基金产品",
                    subtitle: "通过腾讯理财通、蚂蚁财富等互联网第三方平台或银行、券商购买。",
                    buttonText: "找回密码"
                },
                {
                    id: 2,
                    title: "我是手机注册客户",
                    subtitle: "通过手机注册，还未进行实名认证",
                    buttonText: "找回密码"
                }
            ],
            selectedOption: null,
            warningHtml: "",
            commonQuestion: [],
            pwdPattern: null
        };
    },
    computed: {
        // 非空；0-单密码 1-多密码
        passwordType() {
            return this.$cache.getCompanyInfoParam("10109008");
        },
        isMultiPasswordMode() {
            return this.passwordType === "1";
        },
        isLoginGetPwdEntry() {
            return this.$route.query.source === "loginGetPwd";
        }
    },
    watch: {
        "$route.query.selection": {
            handler(val) {
                if (val === undefined || val === null) {
                    this.selectedOption = null;
                } else {
                    this.initSelectedOptionFromRoute();
                }
            }
        }
    },
    created() {
        this.warningHtml = warningHtml.warningHtml1;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion1;
        const registerType = this.$cache.getCompanyInfoParam("10109007");
        const companyName = this.$cache.getCompanyInfoParam("10101014") || "基金公司";

        // 配置的个性化文案信息
        const menuText = this.$cache.getParamValue("menu_text");
        if (menuText && menuText.forgetpwdtext) {
            const forgetpwdtext = menuText.forgetpwdtext;
            this.recoveryOptions.forEach((item) => {
                forgetpwdtext.forEach((subItem) => {
                    if (item.id == subItem.id) {
                        item.title = subItem.title;
                        item.subtitle = subItem.subtitle;
                        item.buttonText = subItem.buttonText || item.buttonText;
                    }
                });
            });
        }
        // 动态替换XXX占位符
        this.recoveryOptions = this.recoveryOptions.map((option) => ({
            id: option.id,
            title: option.title.replace(/XXX/g, companyName),
            subtitle: option.subtitle.replace(/XXX/g, companyName),
            buttonText: option.buttonText
        }));

        // U8-TIS-29909：多密码模式找回的仍是登录密码，入口文案沿用单密码模式且实名入口不受交易密码登录参数控制。
        // 纯代销客户找回登录密码入口仅通过登录页“获取登录密码”进入
        if (!this.isLoginGetPwdEntry) {
            this.recoveryOptions = this.recoveryOptions.filter((item) => {
                return item.id != 1;
            });
        }

        const accountInfo = this.$cache.getParamValue("account_info");
        // 是否屏蔽注册找回密码入口
        if (
            (accountInfo && accountInfo.resetregisterpwdenable == false) ||
            (!this.isMultiPasswordMode && registerType == "0")
        ) {
            this.recoveryOptions = this.recoveryOptions.filter((item) => {
                return item.id != 2;
            });
        }

        // 客户交易密码与登录密码一致的系统参数 24111501  此种情况下不能通过银行卡鉴权找回密码
        this.pwdPattern = this.$cache.getCompanyInfoParam("24111501") == "1";
        this.initSelectedOptionFromRoute();
    },
    methods: {
        initSelectedOptionFromRoute() {
            const routeSelection = Number(this.$route.query.selection);
            if (Number.isNaN(routeSelection)) {
                this.selectedOption = null;
                return;
            }
            const matchedOption = this.recoveryOptions.some((item) => item.id === routeSelection);
            if (matchedOption) {
                this.selectedOption = routeSelection;
            } else {
                this.selectedOption = null;
            }
        },
        selectOption(id) {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    selection: id
                }
            });
        },
        goBack() {
            this.$router.back();
        }
    }
};
</script>
<style lang="scss" scoped>
.comp-reset-num {
    .bizcomp-reset-lpwd-title {
        height: 60px;
        padding: 17px 20px 22px;
        background: #ffffff;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
        box-sizing: border-box;
        .lpwd-title-tip {
            font-size: 16px;
            font-weight: normal;
            color: var(--color-text-accent);
            margin-top: 30px;
        }
    }
    border: 1px solid var(--color-divided);
    margin-bottom: 20px;

    .recoveryOptions-container {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        margin-bottom: 330px;
        padding: 0 20px;
        .recovery-option {
            border: 1px solid var(--color-text-weak);
            margin-bottom: 20px;
            padding: 20px;
            cursor: pointer;
            flex: 1;
            margin-right: 20px;
            max-width: 600px;
            display: flex;
            flex-direction: column;
            &.selected {
                border-color: var(--color-primary);
            }
            button {
                background-color: var(--color-primary);
                color: white;
                border: none;
                padding: 5px 20px;
                cursor: pointer;
                align-self: flex-start;
                margin-top: auto;
            }
            .title {
                font-size: 20px;
                font-weight: 500;
                color: var(--color-text-primary);
                min-height: 55px;
            }
            .subtitle {
                font-size: 14px;
                margin: 10px 0 15px 0;
                color: var(--color-text-accent);
                flex: 1;
            }
        }
    }
}
</style>
